import React, { useState } from "react";
import { useTab } from "../../../contexts/tab";
import classNames from "classnames";
import { deleteIcon, editIcon } from "../../icon";
import ColorForm from "../forms/ColorForm";
import DeleteColorModal from "../forms/DeleteColorModal";
import ShimmerTable from "../../shimmer/ShimmerTable";
import { useAuth } from "../../../contexts/auth";
import { useFormik } from "formik";
import { basePath } from "../../config";
import { toast } from "react-toastify";

export default function TabBodyColor() {
  const [{ tabData }, { setTabData }] = useTab();
  const [isOpen, setIsOpen] = useState(false);
  const [colorToEdit, setColorToEdit] = useState(null);
  const [colorToDelete, setColorToDelete] = useState(null);
  const [{ activeUser }] = useAuth();

  function handaleEdit(data) {
    setColorToEdit(data);
    setIsOpen(true);
  }

  async function submitFormData(values) {
    try {
      const res = await fetch(basePath + "getFilteredColors", {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${activeUser?.remember_token}`,
        },
        body: JSON.stringify(values),
      });
      const data = await res.json();

      if (res.status === 401) {
        toast.error(data.message);
        document.cookie =
          "user=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      }

      if (data.status) {
        setTabData({ data: JSON.parse(data.data), links: [] });
      } else {
        setTabData(null);
      }
    } catch (error) {
      setTabData(null);
      console.error("TabProvider:: api calling fail =>", error);
    }
  }

  const formik = useFormik({
    initialValues: {
      color: "",
    },
    onSubmit: (values, actions) => {
      submitFormData(values, actions, activeUser);
    },
  });

  async function handleReset() {
    formik.resetForm({
      color: "",
    });

    setTabData(null);
    const restApi = "getColors";

    try {
      const res = await fetch(basePath + restApi, {
        method: "post",
        headers: {
          Authorization: `Bearer ${activeUser?.remember_token}`,
          Accept: "application/json",
        },
      });

      const data = await res.json();

      if (res.status === 401) {
        toast.error(data.message);
        document.cookie =
          "user=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      }

      if (data.status) {
        setTabData(JSON.parse(data.data));
      } else {
        setTabData(null);
      }
    } catch (error) {
      setTabData(null);
      console.error("TabProvider:: api calling fail =>", error);
    }
  }

  return (
    <div>
      <div className="flex justify-between bg-slate-200 mb-4 items-center p-2 rounded-md">
        <form
          className="flex gap-3 items-center"
          onSubmit={formik.handleSubmit}
        >
          <label>
            <span className="mr-3">Search:</span>
            <input
              className="rounded-sm py-1 px-2"
              value={formik.values.color}
              onChange={formik.handleChange}
              type="text"
              name="color"
              placeholder="Search Color"
            />
          </label>

          <button className="bg-white rounded-sm px-2 py-1" type="submit">
            Submit
          </button>
          <button
            onClick={handleReset}
            className="bg-white rounded-sm px-2 py-1"
            type="button"
          >
            Reset
          </button>
        </form>
        {activeUser?.user_permission <= 2 && (
          <button
            onClick={() => setIsOpen(true)}
            className="bg-orange text-white p-2 rounded-md"
          >
            Add Color
          </button>
        )}
      </div>

      <ColorForm
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        colorToEdit={colorToEdit}
        setColorToEdit={setColorToEdit}
      />
      <DeleteColorModal
        setColorToDelete={setColorToDelete}
        colorToDelete={colorToDelete}
      />
      {!tabData && <ShimmerTable />}
      {tabData && (
        <table className="dataTable">
          <thead>
            <tr>
              <th scope="col">No</th>
              <th scope="col">Color</th>
              <th scope="col">Note</th>
              {activeUser?.user_permission <= 2 && <th scope="col">Action</th>}
            </tr>
          </thead>
          <tbody>
            {tabData &&
              tabData.data.map(({ id, color, note }, i) => {
                return (
                  <tr key={id}>
                    <td scope="col">{i + (tabData.from || 1)}</td>
                    <td scope="col">{color}</td>
                    <td scope="col">{note}</td>
                    {activeUser?.user_permission <= 2 && (
                      <td scope="col">
                        <button
                          className="bg-green-600 p-2 rounded-md my-1"
                          onClick={() => handaleEdit({ id, color, note })}
                        >
                          {editIcon}
                        </button>
                        <button
                          className={classNames(
                            "p-2 rounded-md ml-2 bg-orange"
                          )}
                          onClick={() => setColorToDelete({ id, color })}
                        >
                          {deleteIcon}
                        </button>
                      </td>
                    )}
                  </tr>
                );
              })}
          </tbody>
        </table>
      )}
    </div>
  );
}
